import { useFormContext } from 'react-hook-form';
import { CTMonitoringPanelFormValues } from '../Pages/CandidateTestMonitoringPage/Components/CTMonitoringTogglesForm';

export interface CandidateTestMonitoring {
    isWebcamEnabled: boolean;
    isFullScreenEnabled: boolean;
    isScreenInvigilationEnabled: boolean;
}

export const DefaultCTMonitoring: CandidateTestMonitoring = {
    isWebcamEnabled: false,
    isFullScreenEnabled: false,
    isScreenInvigilationEnabled: false,
};

export const useCTMonitoringFormContext = () => useFormContext<CTMonitoringPanelFormValues>();
